var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0057 14.6663V7.50862C8.0057 7.28736 8.08421 7.07301 8.22773 6.90237L11.6012 2.89164C12.1236 2.27052 11.6734 1.33301 10.8527 1.33301H2.13935C1.31865 1.33301 0.868442 2.27052 1.39087 2.89164L4.76432 6.90237C4.90784 7.07301 4.98635 7.28736 4.98635 7.50862V12.1663M10.6476 8.41634H13.667M10.6476 10.9163H13.667M10.6476 13.4163H13.667",
    stroke: "#363A44",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filters.08b145fb6941476badee61505d3693d1.svg";